/**
 * The language in effect until an application calls `setLanguage`. English so a
 * package rendered with no application around it — a showcase, a unit test —
 * still shows real copy rather than blanks.
 */
export const DEFAULT_LANGUAGE = 'en';
